const setAccentColor = () => {
	const params = new URLSearchParams(document.location.search.substring(1));

	if (!params) {
		return;
	}

	const accentTypes: string[] = [];

	const [accent, intro, logo] = [
		params.get('accent'),
		params.get('intro'),
		params.get('logo'),
	];

	const styleElement = document.createElement('style');

	if (accent) {
		const hsl = (
			type: string,
			h: string,
			s: string | number,
			l: string | number,
		) => `--${type}: hsl(${h}, ${s}%, ${l}%);`;

		const [h, s, l]: string[] = accent.split(',');

		accentTypes.push(
			hsl('accent', h, s, l),
			hsl('accent-l', h, parseInt(s, 10) - 1, parseInt(l, 10) - 0 + 10),
			hsl('accent-d', h, parseInt(s, 10) - 0 + 1, parseInt(l, 10) - 10),
		);
	}

	if (intro) {
		const declareStyleVariables = (n: string, c: string) => {
			if (c) {
				accentTypes.push(`--intro-${n}: #${c};`);
			}
		};

		// eslint-disable-next-line prefer-const
		let [bg, fg, bbg, bfg] = intro.split(',');

		bfg = bfg || bg;
		bbg = bbg || fg;

		declareStyleVariables('bg', bg);
		declareStyleVariables('fg', fg);
		declareStyleVariables('b-bg', bbg);
		declareStyleVariables('b-fg', bfg);
	}

	if (logo) {
		const [url, width, height] = logo.split(',');

		styleElement.innerHTML = `.rfp-intro-header:after {width:${
			width || 172
		}px;height:${height || 48}px;background:url(${decodeURIComponent(
			url,
		)}) no-repeat;content: '';display:block;background-size:contain;} .rfp-intro-header img {display: none;} `;
	}

	styleElement.innerHTML += `:root{ ${accentTypes.join('')} }`;

	document.head.appendChild(styleElement);
};

export default setAccentColor;
